import { PencilIcon, TrashIcon } from '@/components/icons';
import { Button } from '@/components/ui';
import styles from '@/styles/components/RowActions/style.scss';

interface RowActionsProps {
  name: string;
  onEdit: () => void;
  /** Leave out to show Edit only (e.g. a login that may edit but not delete). */
  onDelete?: () => void;
  /** Why delete is unavailable (e.g. the item is in use); disables the button. */
  deleteBlockedReason?: string;
}

/** Edit and Delete icon buttons on the right of a Manage row. Both open a modal. */
export function RowActions({ name, onEdit, onDelete, deleteBlockedReason }: RowActionsProps) {
  return (
    <div className={styles.actions}>
      <Button size="sm" variant="ghost" iconOnly icon={<PencilIcon size={15} />} aria-label={`Edit ${name}`} title="Edit" onClick={onEdit} />
      {onDelete && (
        <Button
          size="sm"
          variant="ghost"
          iconOnly
          icon={<TrashIcon size={15} />}
          aria-label={`Delete ${name}`}
          title={deleteBlockedReason ?? 'Delete'}
          onClick={onDelete}
          disabled={!!deleteBlockedReason}
        />
      )}
    </div>
  );
}
